import React from 'react'

import GuestCheckout from './GuestCheckout'
import GuestRegister from './GuestRegister'

class GuestCheckoutWithRegistration extends React.Component {
  state = {
    email: '',
    wantsToRegister: false,
  }

  updateEmail = (email) => {
    this.setState({ email })
  }

  toggleChecked = () => {
    this.setState(prevState => ({ wantsToRegister: !prevState.wantsToRegister }))
  }

  renderCheckbox() {
    return (
      <div className="form-group form-group-grey">
        <input
          type="checkbox"
          id="save-details-checkbox"
          className="checkbox"
          checked={this.state.wantsToRegister}
          onChange={this.toggleChecked}
        />
        <label htmlFor="save-details-checkbox" className="text-default">
          Save my details for <span className="text-semibold">easier checkout later</span>
        </label>
      </div>
    )
  }

  render() {
    return (
      <div className="guest-user-checkout-container">
        {this.state.wantsToRegister ? (
          <GuestRegister
            email={this.state.email}
            updateEmail={this.updateEmail}
            checkbox={this.renderCheckbox()}
          />
        ) : (
          <GuestCheckout
            email={this.state.email}
            updateEmail={this.updateEmail}
            checkbox={this.renderCheckbox()}
          />
        )}
      </div>
    )
  }
}

export default GuestCheckoutWithRegistration
